/**
 * @component {"type":"FooterTimeline","version":"1.0"}
 */

define('component-footer-timeline',['knockout', 'helpers', 'jquery'], function (ko, helpers, $) {

    return function (parentVM) {
        var self = this,
            trainingVM = parentVM.training,
            entityVM = parentVM.entity,
            compRanges,
            settings = {
                slidesPerView: 'auto',
                slideClass: 'footer-timeline-item',
                freeMode: true,
                slideToClickedSlide: true,
                grabCursor: true, observer: true //, observeParents: true
            };

        function currentInRange(start, end) {
            return helpers.entity.isInPageRange(trainingVM.trainingContentEntities(), entityVM.ID(), start, end);
        }

        function containerInRange() {
            var rVal = false;
            compRanges.forEach(function (a) {
                if (currentInRange(a.startPage, a.endPage || a.startPage) === true) {
                    rVal = true;
                }
            });
            return rVal;
        }

        self.swiper;
        self.activeIndex = 0;
        self.content = helpers.component.getContent(trainingVM.componentsJSON(), 'FooterTimeline');
        self.inCourse = ko.observable(false);
        self.items = [];

        function update() {      // Update visibility
            var compContainer = document.getElementById('js-footer-timeline-container');

            if (compContainer) {

                var hasClass = (compContainer.className.indexOf("footer-timeline-active") > -1),
                    inRange = containerInRange();

                if (inRange && !hasClass) {
                    compContainer.className += " footer-timeline-active";
                    parentVM.layout.staticBodyClasses.push('footer');
                } else if (!inRange && hasClass) {
                    compContainer.className = compContainer.className.replace("footer-timeline-active", "");
                    parentVM.layout.staticBodyClasses.remove('footer');
                }
            }
            if (!isNaN(self.activeIndex)) {
                $('.timeline-item-active').removeClass('timeline-item-active');
                $('.footer-timeline-item[data-index=' + self.activeIndex + ']').addClass('timeline-item-active');

                if (self.swiper && self.swiper.slideTo && self.swiper.update) {
                    self.swiper.slideTo(self.activeIndex, 1000, true);
                    self.swiper.activeIndex = self.activeIndex;
                    self.swiper.update();
                }
            }
        }

        if (self.content.items && self.content.items.length > 0) {

            compRanges = helpers.component.parseProp(self.content, 'visibleRanges', 'PageRange');

            self.inCourse(true);

            setTimeout(update, 300);

            self.items = ko.computed(function () {

                var arr = helpers.component.parseProp(self.content, 'items', 'FooterTimelineItem');

                self.activeIndex = -1;
                arr.forEach(function (a, i) {
                    a.active = currentInRange(a.startPage, a.endPage);
                    if (a.active) {
                        self.activeIndex = i;
                    }
                });

                update();

                return (arr.length) ? arr : [];
            });

            require(['swiper'], function (Swiper) {
                var container = document.getElementById('js-footer-timeline-container');

                self.swiper = new Swiper(container, settings);

                if (self.swiper.on) {
                    self.swiper.on('touchEnd', function () {
                        setTimeout(function () {
                            self.swiper.slideTo(self.activeIndex, 1000, true);
                            self.swiper.activeIndex = self.activeIndex;
                            self.swiper.update();
                        }, 300);
                    });
                }

                // Remove bindings
                var element = $('#footer')[0];
                ko.cleanNode(element);

                if (!container || !self.swiper) {
                    return;
                }
            });
        }
        /*
                self.getContent = function(index, prop) {
                    var items = self.items(),
                        item = (items) ? items[index] : null;

                    return (item && item.hasOwnProperty(prop) && item[prop]) ? item[prop] : (prop === 'body') ? '<p></p>' : '';
                };
        */
    };

});

